const apiUrl = process.env.REACT_APP_API_URL;

const getLubricantManufacturers = (token, searchTerm, cb) => {
    fetch(`${apiUrl}/lubricantmanufacturers?searchTerm=${searchTerm}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getLubricantManufacturers;
